export default __webpack_public_path__ + "resources/icons/d122-5278.png";